import { render, staticRenderFns } from "./MultiTrainForm.vue?vue&type=template&id=8b9b24b0"
import script from "./MultiTrainForm.vue?vue&type=script&lang=js"
export * from "./MultiTrainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports